type HelpArticleKey = 'termDatabase' | 'onlineEditing' | 'vipChat'

const trimTrailingSlash = (value?: string) => value?.replace(/\/+$/, '') || ''
const trimLeadingSlash = (value: string) => value.replace(/^\/+/, '')

const helpArticlePaths: Record<'zh' | 'en', Record<HelpArticleKey, string>> = {
  zh: {
    termDatabase: 'zh/article/5lua5lmi5piv5pyv6kt6kgo77yf-1euf04r/?bust=1741778662786',
    onlineEditing: 'zh/article/5aac5l2v5l255so5zyo57q57yw57yj5yqf6io9-1xd0vfl/',
    vipChat: 'zh/article/vipchatgptgemini-1kl3by2/',
  },
  en: {
    termDatabase: 'en/article/what-is-a-terminology-database-1x9gcdk/?bust=1741782156184',
    onlineEditing: 'en/article/doclingo-online-editing-guide-17zhpj4/',
    vipChat: 'en/article/vip-chatgpt-gemini-1kl3by2/',
  },
}

export const useAppDomainConfig = () => {
  const publicConfig = useRuntimeConfig().public

  const buildUrl = (baseUrl: string, path = '') => {
    const normalizedBase = trimTrailingSlash(baseUrl)
    const normalizedPath = trimLeadingSlash(path)
    return normalizedPath ? `${normalizedBase}/${normalizedPath}` : normalizedBase
  }

  const getHelpArticleUrl = (key: HelpArticleKey, useChineseArticle = false) => {
    const lang = useChineseArticle ? 'zh' : 'en'
    return buildUrl(publicConfig.helpCenterUrl as string, helpArticlePaths[lang][key])
  }

  const getResourceUrl = (path = '') => buildUrl(publicConfig.resourceUrl as string, path)

  return {
    apiUrl: computed(() => publicConfig.apiUrl as string),
    resourceUrl: computed(() => publicConfig.resourceUrl as string),
    downloadUrl: computed(() => publicConfig.downloadUrl as string),
    linkUrl: computed(() => publicConfig.linkUrl as string),
    doclingoUrl: computed(() => publicConfig.doclingoUrl as string),
    helpCenterUrl: computed(() => publicConfig.helpCenterUrl as string),
    contactEmail: computed(() => publicConfig.contactEmail as string),
    fileBrandSuffix: computed(() => publicConfig.fileBrandSuffix as string),
    pdfEditorUrl: computed(() => publicConfig.pdfEditorUrl as string),
    getHelpArticleUrl,
    getResourceUrl,
  }
}
